import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { AppDispatch, RootState } from '../../store';
import { AUTH_CONSTANTS } from '../../config/constants/auth';
import { checkAuth } from '../../store/slices/authSlice';
import { tokenService } from '../../services/api/auth/token.service';

export const useAuth = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { user, isAuthenticated, role, isLoading, error, clientId, clientResourceId, promoCode } =
    useSelector((state: RootState) => state.auth);

  useEffect(() => {
    // Clear token cache when component mounts
    tokenService.clearToken();
    dispatch(checkAuth());
  }, [dispatch]);

  return {
    user,
    isAuthenticated,
    role,
    isLoading,
    error,
    clientId,
    clientResourceId,
    promoCode,
    isAdmin: role === AUTH_CONSTANTS.ROLES.SUPER_ADMIN,
    isDealerAdmin: role === AUTH_CONSTANTS.ROLES.DEALER_ADMIN,
  };
};
